import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="hussar-payment-page">
      <div className="hussar-payment-container">
        <Card className="hussar-payment-card">
          <XCircle className="hussar-payment-icon" style={{ color: '#B3B3B3' }} />
          <h1 className="hussar-payment-title">{t('payment.cancelTitle')}</h1>
          <p className="hussar-payment-message">
            {t('payment.cancelMessage')}
          </p>
          <div className="hussar-payment-actions">
            <Button
              onClick={() => navigate('/pricing')}
              className="hussar-btn-primary"
              data-testid="payment-cancel-retry-btn"
            >
              {t('payment.tryAgain')}
            </Button>
            <Button
              onClick={() => navigate('/app')}
              className="hussar-btn-secondary"
              data-testid="payment-cancel-back-btn"
            >
              {t('payment.backToApp')}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;
